const InfoIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 7.99999C1.33334 4.31809 4.31811 1.33333 8.00001 1.33333C11.6819 1.33333 14.6667 4.31809 14.6667 7.99999C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667ZM8.00001 13.3333C10.9455 13.3333 13.3333 10.9455 13.3333 7.99999C13.3333 5.05447 10.9455 2.66666 8.00001 2.66666C5.05449 2.66666 2.66668 5.05447 2.66668 7.99999C2.66668 10.9455 5.05449 13.3333 8.00001 13.3333ZM7.33334 4.66666H8.66668V5.99999H7.33334V4.66666ZM7.33334 7.33333H8.66668V11.3333H7.33334V7.33333Z"
        fill="#94979C"
      />
    </svg>
  );
};

export default InfoIcon;
